import { StoredFilterDescription } from 'app/redux/processing/reducer';
import { AcquisitionConstantsByProfile } from 'app/utils/acquisitionConstants';
import { ProcessingFiltersAssociationBySpecieAndRegion } from 'app/utils/PROCESSING_OPTIONS';
import { createContext } from 'react';

export type SharedUserConfig = {
  noXRayDeletion: boolean;
  acquisitionConstants?: AcquisitionConstantsByProfile;
  processingFilters?: StoredFilterDescription[];
  processingFiltersAssociationByProfile?: ProcessingFiltersAssociationBySpecieAndRegion;
  isProcessingFineTuningEnabled?: boolean;
};

export interface SharedUserConfigurationAPI {
  // This function should update the user configuration on the server
  // It should handle the retry mechanism
  update: (config: SharedUserConfig) => Promise<void>;

  get: () => Promise<SharedUserConfig>;
}

export const SharedUserConfigurationAPIContext =
  createContext<SharedUserConfigurationAPI>(undefined);
